import type { RouteObject } from 'react-router-dom';
import { RequireModule } from './guards';
import { builtModules } from '@/modules/registry';

/**
 * The module half of the route table, generated from the registry.
 *
 * Every module's routes are wrapped in `RequireModule` for that same manifest,
 * by the same array the sidebar and the apps grid are drawn from — so a module
 * cannot be drawn and unguarded, or guarded and undrawn, and adding a module
 * never means remembering to add a guard.
 *
 * `shell` routes render inside `DashboardLayout`; `print` routes render outside
 * it, because a printed sheet is the whole page.
 */
export function moduleRouteGroups(kind: 'shell' | 'print'): RouteObject[] {
  return builtModules()
    .map((module) => ({
      module,
      children: kind === 'shell' ? module.routes : (module.printRoutes ?? []),
    }))
    .filter(({ children }) => children.length > 0)
    .map(({ module, children }) => ({
      element: <RequireModule module={module} />,
      children,
    }));
}
